<template>
  <SourcingBoardView
    storage-key="sourcingBoard"
    :description="description"
  />
</template>

<script>
// 분석(수강생) 소싱관리 — 화면 본체는 로켓그로스 소싱관리와 같은 컴포넌트를 쓴다.
// 두 벌을 유지하면 한쪽만 고치는 사고가 나서(계산은 utils/purchaseCost 로 이미 합쳤다)
// 화면도 합쳤다. 이 보드는 boardType 없이 저장되는 기존 행을 담당한다.
import SourcingBoardView from '@/components/common/SourcingBoardView'

export default {
  name: 'SourcingBoard',
  components: { SourcingBoardView },
  data () {
    return {
      description: '담긴 상품을 1688 → 스펙 → 마진 → 확정으로 미는 작업 큐예요 · 컬럼 묶음이 곧 단계고, 색이 칠해진 묶음이 지금 할 일이에요'
    }
  }
}
</script>
